import { render, staticRenderFns } from "./PunchPlates_v1_27_0.vue?vue&type=template&id=1b715039&scoped=true"
import script from "./PunchPlates_v1_27_0.vue?vue&type=script&lang=js"
export * from "./PunchPlates_v1_27_0.vue?vue&type=script&lang=js"
import style0 from "./PunchPlates_v1_27_0.vue?vue&type=style&index=0&id=1b715039&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b715039",
  null
  
)

export default component.exports